// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoInterationSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PtoInterationSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoInterationSquareOutlined = function PtoInterationSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoInterationSquareOutlinedSvg
  }));
};

PtoInterationSquareOutlined.displayName = 'PtoInterationSquareOutlined';
export default React.forwardRef(PtoInterationSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoInterationSquareOutlined.js
// module id = 3899
// module chunks = 0